import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PoliticaCookies() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">Política de Cookies</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-black mb-6">POLÍTICA DE COOKIES DA +KUDIMA</h1>
          <p className="text-lg md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Informações sobre a utilização de cookies no website da +KUDIMA
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Titular do Website */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              Titular do Website
            </h2>
            <div className="bg-[#F8F8F8] rounded-2xl p-8">
              <p className="text-lg text-gray-800 mb-2 font-semibold">MAISKUDIMA – Consultoria Estratégica, Lda</p>
              <p className="text-base text-gray-700 mb-1">Rua Eduardo Mondlane, N.º 210</p>
              <p className="text-base text-gray-700 mb-3">Maianga, Luanda</p>
              <p className="text-base text-gray-700">
                E-mail: <a href="mailto:info@kudima.co.ao" className="text-[#CB9832] hover:underline cursor-pointer">info@maiskudima.com</a>
              </p>
            </div>
          </div>

          {/* Introdução */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              INTRODUÇÃO
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                A MAISKUDIMA – Consultoria Estratégica, Lda. (doravante "+KUDIMA" ou "Responsável pelo Tratamento"), é responsável pelo presente website – www.kudima.co.ao (doravante o "Website").
              </p>
              <p>
                A presente Política de Cookies tem como objectivo informar os utilizadores sobre a utilização de cookies e tecnologias similares no âmbito da navegação no Website, explicando quais os dados recolhidos, para que fins são utilizados e como podem ser geridos.
              </p>
              <p>
                Para mais informações sobre o tratamento de dados pessoais, recomenda-se a consulta da Política de Privacidade da +KUDIMA.
              </p>
            </div>
          </div>

          {/* Enquadramento Legal */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              ENQUADRAMENTO LEGAL
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                O tratamento de dados realizado através de cookies observa a legislação aplicável em matéria de protecção de dados pessoais, nomeadamente:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Princípios gerais de protecção de dados e privacidade aplicáveis à República de Angola;</li>
                <li>Boas práticas internacionais em matéria de protecção de dados e transparência digital.</li>
              </ul>
              <p>
                A +KUDIMA compromete-se a tratar os dados pessoais de forma lícita, leal e transparente.
              </p>
            </div>
          </div>

          {/* O que são Cookies */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              O QUE SÃO COOKIES?
            </h2>
            <div className="text-base text-gray-700 leading-relaxed">
              <p>
                Cookies são pequenos ficheiros de texto armazenados no dispositivo do utilizador (computador, tablet ou telemóvel) quando visita um website. Estes ficheiros permitem reconhecer o dispositivo do utilizador em visitas futuras, melhorar a experiência de navegação e recolher informações estatísticas.
              </p>
            </div>
          </div>

          {/* Tipos de Cookies */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              TIPOS DE COOKIES UTILIZADOS
            </h2>
            <div className="space-y-6 text-base text-gray-700 leading-relaxed">
              <p>O Website da +KUDIMA poderá utilizar os seguintes tipos de cookies:</p>
              
              <div className="bg-[#F8F8F8] rounded-2xl p-6">
                <h3 className="text-xl font-bold text-black mb-3">1. Cookies Estritamente Necessários (Cookies Técnicos)</h3>
                <p className="mb-2">
                  Estes cookies são essenciais para o funcionamento do Website e permitem funcionalidades básicas, como a navegação segura e o acesso a áreas protegidas.
                </p>
                <p className="mb-2">
                  Sem estes cookies, o Website poderá não funcionar correctamente.
                </p>
                <p className="font-semibold">Não carecem de consentimento do utilizador.</p>
              </div>

              <div className="bg-[#F8F8F8] rounded-2xl p-6">
                <h3 className="text-xl font-bold text-black mb-3">2. Cookies de Análise ou Estatísticos</h3>
                <p className="mb-2">
                  Estes cookies permitem recolher informações de forma agregada e anónima sobre a forma como os utilizadores utilizam o Website (por exemplo, páginas visitadas, tempo de permanência), com o objectivo de melhorar o desempenho e os conteúdos disponibilizados.
                </p>
                <p className="font-semibold">Carecem do consentimento do utilizador.</p>
              </div>

              <div className="bg-[#F8F8F8] rounded-2xl p-6">
                <h3 className="text-xl font-bold text-black mb-3">3. Cookies de Funcionalidade</h3>
                <p className="mb-2">
                  Permitem memorizar preferências do utilizador, como idioma ou definições de navegação, proporcionando uma experiência mais personalizada.
                </p>
                <p className="font-semibold">Carecem do consentimento do utilizador.</p>
              </div>

              <div className="bg-[#F8F8F8] rounded-2xl p-6">
                <h3 className="text-xl font-bold text-black mb-3">4. Cookies de Terceiros</h3>
                <p className="mb-2">
                  O Website poderá recorrer a serviços de terceiros (por exemplo, ferramentas de análise, conteúdos incorporados ou redes sociais), os quais poderão instalar cookies próprios.
                </p>
                <p>
                  A +KUDIMA não controla directamente estes cookies, sendo cada terceiro responsável pela respectiva gestão e conformidade legal.
                </p>
              </div>
            </div>
          </div>

          {/* Consentimento */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              CONSENTIMENTO PARA A UTILIZAÇÃO DE COOKIES
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                Sempre que exigido, os cookies apenas serão instalados após o consentimento expresso do utilizador, através do banner ou ferramenta de gestão de cookies disponibilizada no Website.
              </p>
              <p>
                O utilizador poderá, a qualquer momento, alterar ou retirar o seu consentimento.
              </p>
            </div>
          </div>

          {/* Como Gerir Cookies */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              COMO GERIR OU DESACTIVAR COOKIES?
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                O utilizador pode configurar o seu navegador para aceitar, recusar ou eliminar cookies.
              </p>
              <p>
                A desactivação de determinados cookies poderá afectar o correcto funcionamento do Website.
              </p>
              <p className="font-semibold">Links úteis para gestão de cookies nos navegadores mais comuns:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#CB9832] hover:underline cursor-pointer">
                    Google Chrome
                  </a>
                </li>
                <li>
                  <a href="https://support.mozilla.org/pt-PT/kb/cookies" target="_blank" rel="noopener noreferrer" className="text-[#CB9832] hover:underline cursor-pointer">
                    Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a href="https://support.apple.com/pt-pt/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#CB9832] hover:underline cursor-pointer">
                    Safari
                  </a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/pt-pt/microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-[#CB9832] hover:underline cursor-pointer">
                    Microsoft Edge
                  </a>
                </li>
                <li>
                  <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer" className="text-[#CB9832] hover:underline cursor-pointer">
                    Opera
                  </a>
                </li>
              </ul>
              <p className="text-sm italic">(As configurações variam consoante o navegador e o dispositivo utilizado.)</p>
            </div>
          </div>

          {/* Actualizações */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              ACTUALIZAÇÕES DA POLÍTICA DE COOKIES
            </h2>
            <div className="space-y-4 text-base text-gray-700 leading-relaxed">
              <p>
                A +KUDIMA reserva-se o direito de actualizar a presente Política de Cookies sempre que necessário, sendo quaisquer alterações publicadas neste Website.
              </p>
              <p>
                Recomenda-se a consulta periódica desta página.
              </p>
            </div>
          </div>

          {/* Contactos */}
          <div className="mb-16">
            <h2 className="text-lg font-bold text-black mb-6 pb-4 border-b-2 border-[#CB9832]">
              CONTACTOS
            </h2>
            <div className="text-base text-gray-700 leading-relaxed">
              <p>
                Para quaisquer questões relacionadas com a presente Política de Cookies ou com a protecção de dados pessoais, poderá contactar a +KUDIMA através do seguinte endereço electrónico:{' '}
                <a href="mailto:info@kudima.co.ao" className="text-[#CB9832] hover:underline cursor-pointer font-semibold">
                  info@maiskudima.com
                </a>
              </p>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gradient-to-br from-[#2D5F3F] to-[#234A32] rounded-3xl p-10 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">Tem alguma dúvida?</h3>
            <p className="text-lg mb-3  opacity-90">
              Entre em contacto connosco para esclarecimentos adicionais sobre a nossa política de cookies.
            </p>
            <a
              href="/contato"
              className="inline-block bg-[#CB9832] text-white px-8 py-3 rounded-lg font-bold text-lg hover:bg-[#B8872D] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              CONTACTE-NOS
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
